/* eslint-disable react/no-danger */
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

function CruiseCard({ trip }) {
  const {
    name,
    departure_date,
    return_date,
    only_in_combination,
    destinations,
    translated,
    summary,
    cabins,
    url,
    map,
  } = trip;
  const price = cabins?.[0]?.price || 'N/A';
  const slug = url.split('/').pop();

  return (
    <div
      style={{
        border: '1px solid #ccc',
        borderRadius: '10px',
        overflow: 'hidden',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        height: '100%',
      }}
    >
      {/* Image */}
      <Link to={`/cruise/${slug}`}>
        <img
          src={map}
          alt={trip.name}
          style={{ width: '100%', height: '180px', objectFit: 'cover' }}
        />
      </Link>

      {/* Content */}
      <div style={{ paddingLeft: '5px', flexGrow: 1 }}>
        <Link to={`/cruise/${slug}`} style={{ textDecoration: 'none' }}>
          <h3 style={{ margin: '0 0 8px', fontSize: '18px', color: '#007b8f' }}>
            {name}
          </h3>
        </Link>

        <p style={{ fontSize: '14px', color: '#555' }}>
          {departure_date} to {return_date}
        </p>

        {/* Extra Info Below Dates */}
        {only_in_combination && (
          <p style={{ color: 'red', fontWeight: 'bold', margin: '4px 0' }}>
            Can be booked in combination only
          </p>
        )}
        {destinations?.length > 0 && (
          <div style={{ fontSize: '14px', padding: '0px', margin: '0px' }}>
            {destinations.map((destination, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <span key={index}>{destination},</span>
            ))}
          </div>
        )}
        {translated && (
          <p
            style={{
              margin: '4px 0',
              display: 'inline-block',
              padding: '2px 6px',
              backgroundColor: '#ffe4b3',
              borderRadius: '50%',
              fontSize: '12px',
            }}
          >
            EN
          </p>
        )}

        {/* Summary */}
        <div
          style={{
            marginTop: '10px',
            marginBottom: '10px',
            fontSize: '11px',
            color: '#444',
          }}
          dangerouslySetInnerHTML={{ __html: summary }}
        />
      </div>

      {/* Price Box */}
      <div
        style={{
          margin: '5px',
          padding: '5px',
          bottom: '10px',
          left: '0',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {/* Left button */}
        <Link
          to={`/cruise/${slug}`}
          style={{
            backgroundColor: '#3498db',
            borderRadius: '6px',
            fontWeight: 'bold',
            color: 'white',
            fontSize: '14px',
            textDecoration: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '5px',
            padding: '5px',
          }}
        >
          Go to Cruise Page
        </Link>

        {/* Right price tag */}
        <div
          style={{
            marginTop: '10px',
            backgroundColor: '#ffe4b3',
            borderRadius: '6px',
            fontWeight: 'bold',
            color: '#d35400',
            fontSize: '14px',
            margin: '5px',
            padding: '5px',
          }}
        >
          USD ${price}
        </div>
      </div>
    </div>
  );
}

CruiseCard.propTypes = {
  trip: PropTypes.shape({
    name: PropTypes.string,
    departure_date: PropTypes.string,
    return_date: PropTypes.string,
    only_in_combination: PropTypes.bool,
    translated: PropTypes.bool,
    summary: PropTypes.string,
    map: PropTypes.string,
    destinations: PropTypes.arrayOf(PropTypes.string),
    cabins: PropTypes.arrayOf(
      PropTypes.shape({
        price: PropTypes.number,
      }),
    ),
    url: PropTypes.string,
  }).isRequired,
};

export default CruiseCard;
